// extracted by mini-css-extract-plugin
module.exports = {"isSearch":"meal_isSearch__3z6R-"};